// removed by extract-text-webpack-plugin
module.exports = {"Overlay":"FormRegistration__Overlay___TRceN","Modal":"FormRegistration__Modal___3HhDj","CloseButton":"FormRegistration__CloseButton___3VJtJ","Title":"FormRegistration__Title___2PQV4","WorkTypeSpan":"FormRegistration__WorkTypeSpan___1B2vH","Input":"FormRegistration__Input___Rh_Tk","InputError":"FormRegistration__InputError___7_u5p","Wrapper":"FormRegistration__Wrapper___1GWGL","Loader":"FormRegistration__Loader___3L524","loader10":"FormRegistration__loader10___iXJuE","SubmitButton":"FormRegistration__SubmitButton___3eAka","Politician":"FormRegistration__Politician___2LGM8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/FormRegistration/FormRegistration.scss
// module id = 1359
// module chunks = 0